
<div>
  <collapsible-section
      class="collapse-item"
      :id="`dynamicInputsCollapse-${dynamicInputObject.id}-${dropdownControlId}`"
      control-name="dynamicInputCollapse"
      :is-open="false"
  >
    <template #section-header>
      {{ dynamicInputObject.name }}
    </template>

    <template #section-contents>
      <field-item
          @click="select(dynamicInputsSection.select(dynamicInputObject, path))"
          :disabled="handler.isDisabled(dynamicInputObject, parentTreeContext)"
      >
        <row>
          <prefix>
            <icon glyph="box"/>
          </prefix>
          <column>
            {{ dynamicInputObject.name }}
          </column>
        </row>
      </field-item>

      <collapsible-section
          class="collapse-item"
          :id="`dynamicInputPropertiesCollapse-${dynamicInputObject.id}-${dropdownControlId}-properties`"
          control-name="dynamicInputPropertiesCollapse"
          :is-open="false"
      >
        <template #section-header>
          Properties
        </template>

        <template #section-contents>
          <dynamic-input-section-data
              :handler="handler"
              :q="q"
              :section="dynamicInputsSection"
              :parent-tree-context="computedChildTreeContext"
              :path="path"
              @select="select"
          ></dynamic-input-section-data>
        </template>
      </collapsible-section>
    </template>
  </collapsible-section>
</div>
